import { HappinessIndexCreate } from "components/hr-metrics/happiness-index/create/HappinessIndexCreate";
import { ImportDataContainer } from "containers/hr-metrics/happiness-index/create/ImportDataContainer";
import SelectPeriodContainer from "containers/hr-metrics/happiness-index/create/SelectPeriodContainer";
import { useLocation } from "react-router-dom";
import { getPathUrl } from "utils/utils";

const HappinessIndexCreateContainer = () => {
    const location = useLocation()
    const lastPath = getPathUrl(location, '/', -1).toString()

    const content = (path) => {
        switch (path) {
            case 'select-period':
                return {
                    path: 'select-period',
                    item: <SelectPeriodContainer/>,
                    sequence: 1
                }
            case 'import-data':
                return {
                    path: 'import-data',
                    item: <ImportDataContainer/>,
                    sequence: 2
                }
            default:
                return {
                    path: 'select-period',
                    item: <SelectPeriodContainer/>,
                    sequence: 1
                }
        }
    } 
    

    return (
        <HappinessIndexCreate content={content} lastPath={lastPath}/>
    )
}

export default HappinessIndexCreateContainer
